import React from "react";
import { logErrorToDataDog } from "../utils/datadog-utils";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidMount() {
    this.originalConsoleError = console.error;
    this.originalConsoleWarn = console.warn;
    this.originalConsoleLog = console.log;

    console.error = (...args) => {
      logErrorToDataDog(new Error(args.join(" ")), null, {
        source: "ConsoleError",
      });
      this.originalConsoleError.apply(console, args);
    };

    console.warn = (...args) => {
      logErrorToDataDog(new Error(args.join(" ")), null, {
        source: "ConsoleWarn",
      });
      this.originalConsoleWarn.apply(console, args);
    };
  }

  componentWillUnmount() {
    console.error = this.originalConsoleError;
    console.warn = this.originalConsoleWarn;
    console.log = this.originalConsoleLog;
  }

  componentDidCatch(error, errorInfo) {
    logErrorToDataDog(error, errorInfo, { source: "ErrorBoundary" });
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || this.props.children;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
